import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

import * as thunk from './thunk';

export const initialState = {
    dataList: [],
    error: {},
    loading: true
};

const SiteSlice = createSlice({
    name: 'Sites',
    initialState,
    reducers: {},
    extraReducers: builder => {
        // <--------------------------- getAll --------------------------->
        builder.addCase(thunk.getAll.fulfilled, (state, action) => {
            state.dataList = action.payload;
            state.loading = true;
        });
        builder.addCase(thunk.getAll.rejected, (state, action) => {
            state.error = action?.error || {};
        });

        // <--------------------------- create --------------------------->
        builder.addCase(thunk.create.fulfilled, (state, action) => {
            state.dataList.unshift(action.payload);
        });
        builder.addCase(thunk.create.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        // <--------------------------- update --------------------------->
        builder.addCase(thunk.update.fulfilled, (state, action) => {
            const id = action?.payload.id;
            if (_.isEmpty(id)) {
                return;
            }

            const dataList = (state.dataList || []).filter(x => x.id !== id);
            dataList.unshift(action.payload);
            state.dataList = dataList;
        });

        builder.addCase(thunk.update.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        // <--------------------------- remove --------------------------->
        builder.addCase(thunk.remove.fulfilled, (state, action) => {
            state.dataList = state.dataList.filter(x => x.id !== action.payload);
        });
        builder.addCase(thunk.remove.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });
    }
});

export default SiteSlice.reducer;
